import { useEffect } from 'react';
import { useTrackView } from './useListingAnalytics';

// Hook to automatically track page views for listings
export const useViewTracking = (listingId: string | null, enabled: boolean = true) => {
  const { trackView } = useTrackView();

  useEffect(() => {
    // Only track if enabled and we have a listing ID
    if (enabled && listingId) {
      // Track view with a small delay to avoid tracking during rapid navigation
      const timer = setTimeout(() => {
        trackView(listingId);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [listingId, enabled, trackView]);
};